import { easasAlert } from "components/fragments/easas-global-fragment/EasasGlobalAlerts";
import { toBlob } from "html-to-image";
import { PlotlyHTMLElement } from "plotly.js";

const copyChartToClipBoard = (gd: PlotlyHTMLElement) => {
  const el = gd.firstChild?.firstChild as HTMLDivElement;
  const modebar = el.getElementsByClassName("modebar-container")[0];

  el.removeChild(modebar);

  toBlob(el, { skipFonts: true })
    .then(function (blob) {
      navigator.clipboard
        .write([
          new ClipboardItem({
            "image/png": blob!,
          }),
        ])
        .then(() =>
          easasAlert({
            summary: "Clipboard",
            detail: "Chart copied to clipboard",
          })
        );
    })
    .catch(function (error) {
      easasAlert({
        summary: "Clipboard",
        detail: "This feature may not be supported on you browser",
        severity: "error",
      });
      console.error("Something went wrong!", error);
    })
    .finally(() => {
      el.appendChild(modebar);
    });
};

export default copyChartToClipBoard;
